module.exports = __webpack_public_path__ + "img/ambiental-5.b8aeff99.jpg";